export default __webpack_public_path__ + "static/media/405_top.62ec1ef6.svg";